"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerFooter = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
var Divider_1 = __importDefault(require("@material-ui/core/Divider"));
var DrawerContext_1 = require("./DrawerContext");
var clsx_1 = __importDefault(require("clsx"));
var useStyles = makeStyles_1.default({
    root: {
        width: '100%',
        backgroundColor: function (props) { return props.backgroundColor; },
    },
    hidden: {
        visibility: 'hidden',
    },
});
var DrawerFooterRender = function (props, ref) {
    var _a;
    var classes = useStyles(props);
    var children = props.children, _b = props.divider, divider = _b === void 0 ? true : _b, 
    // ignore unused vars so that we can do prop transferring to the root element
    /* eslint-disable @typescript-eslint/no-unused-vars */
    backgroundColor = props.backgroundColor, 
    /* eslint-enable @typescript-eslint/no-unused-vars */
    hideContentOnCollapse = props.hideContentOnCollapse, otherDivProps = __rest(props, ["children", "divider", "backgroundColor", "hideContentOnCollapse"]);
    var _c = DrawerContext_1.useDrawerContext().open, drawerOpen = _c === void 0 ? true : _c;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        divider && react_1.default.createElement(Divider_1.default, null),
        react_1.default.createElement("div", __assign({ ref: ref, className: clsx_1.default(classes.root, (_a = {}, _a[classes.hidden] = !drawerOpen && hideContentOnCollapse, _a)) }, otherDivProps), children)));
};
/**
 * [DrawerFooter](https://brightlayer-ui-components.github.io/react/?path=/info/components-drawer--get-read-me-story) component
 *
 * The `<DrawerFooter>` is an optional section that renders at the bottom of the `<Drawer>`. It can be used to add any custom content (as children).
 */
exports.DrawerFooter = react_1.default.forwardRef(DrawerFooterRender);
exports.DrawerFooter.displayName = 'DrawerFooter';
exports.DrawerFooter.propTypes = {
    backgroundColor: prop_types_1.default.string,
    divider: prop_types_1.default.bool,
    hideContentOnCollapse: prop_types_1.default.bool,
};
exports.DrawerFooter.defaultProps = {
    divider: true,
    hideContentOnCollapse: true,
};
